import { createFileRoute, Outlet } from '@tanstack/react-router'

import { AuthLayout } from '@/features/auth'

export const Route = createFileRoute('/_auth')({
  component: AuthShellRoute
})

function AuthShellRoute() {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  )
}
